// // ThermalInvoice.js
// import React, { useContext, useRef } from "react";
// import jsPDF from "jspdf";
// import html2canvas from "html2canvas";
// import styles from "./ThermalInvoice.module.css";
// import AuthContext from "../../../store/auth-context";
// import ActiveStoreContext from "../../../store/ActiveStoreContext";

// const ThermalInvoice = ( props ) => {
//     const { invoiceDataMaster } = props
//     const printRef = useRef();
//     const authCtx = useContext(AuthContext)
//     const asCtx = useContext(ActiveStoreContext);
//     const activeStore = (() => { try { return asCtx?.activeStore && asCtx.activeStore.trim() !== "" ? JSON.parse(asCtx.activeStore) : null; } catch { return null; } })();

//     console.log(invoiceDataMaster)

//     const invoiceData = {
//         sessionIdentifier: "001721807041000002e3170e02bb175648299620250829",
//         discountType: "percentage",
//         dueDate: "2025-08-29",
//         invoiceDate: "2025-08-29",
//         invoiceNumber: "INV-2025-0830-001",
//         clientName: "Annu Sharma",
//         clientPhone: "+91 9876543210",
//         clientEmail: "annu@example.com",
//         items: [
//             { name: "Hair Cut", qty: 1, price: 300 },
//             { name: "Hair Color", qty: 1, price: 1500 },
//             { name: "Face Cleanup", qty: 1, price: 700 },
//         ],
//         discount: 10,
//         taxRate: 18,
//         paidAmount: 2000,
//     };

//     const subTotal = invoiceData?.items?.reduce(
//         (acc, item) => acc + item.qty * item.price,
//         0
//     );

//     const paidTotal = invoiceDataMaster?.collectionData?.reduce(
//         (acc, item) => acc + item?.amount,
//         0
//     );
//     const discountAmount = (subTotal * invoiceData.discount) / 100;
//     const taxedAmount = ((subTotal - discountAmount) * invoiceData.taxRate) / 100;
//     const totalAmount = subTotal - discountAmount + taxedAmount;

//     const handleDownload = async () => {
//         const input = printRef.current;
//         const canvas = await html2canvas(input, { scale: 2 });
//         const imgData = canvas.toDataURL("image/png");

//         const pdf = new jsPDF({
//             orientation: "portrait",
//             unit: "mm",
//             format: [80, canvas.height * 0.2645], // 80mm thermal width
//         });

//         pdf.addImage(imgData, "PNG", 0, 0, 80, (canvas.height * 80) / canvas.width);
//         pdf.save(`${invoiceData.invoiceNumber}.pdf`);
//     };

//     return (
//         <div className={styles.container}>
//             <div className={styles.invoice} ref={printRef}>
//                 <h2 className={styles.title}>{activeStore?.storeName}</h2>
//                 <div className={styles.storeAddress} >
//                     {activeStore?.storeAddress}
//                 </div>
//                 <p>Invoice #: {invoiceDataMaster?.invoiceNumber}</p>
//                 <p>Date: {invoiceDataMaster?.invoiceDate}</p>
//                 <hr />

//                 <p>
//                     <strong>Client:</strong> {invoiceDataMaster?.clientData?.clientName}
//                     <br />
//                     {invoiceDataMaster?.clientData?.mobile}
//                     <br />
//                     {invoiceDataMaster?.clientData?.clientEmail}
//                 </p>
//                 <hr />

//                 <table className={styles.table}>
//                     <thead>
//                         <tr>
//                             <th>Item</th>
//                             <th>Qty</th>
//                             <th>Price</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {invoiceDataMaster?.productData?.map((item, index) => (
//                             <tr key={index}>
//                                 <td>{item.productTitle}</td>
//                                 <td>{item.qty}</td>
//                                 <td>₹{item?.total}</td>
//                             </tr>
//                         ))}
//                     </tbody>
//                 </table>
//                 <hr />


//                 <h3>Total: ₹{invoiceDataMaster?.grandTotal}</h3>
//                 <p>
//                     <strong>Paid:</strong> ₹{paidTotal}
//                     <br />
//                     <strong>Due:</strong> ₹{invoiceDataMaster?.remainingAmount}
//                 </p>
//                 <hr />
//                 <p className={styles.footer}>Thank you for visiting!</p>
//             </div>

//             <button className={styles.downloadBtn} onClick={handleDownload}>
//                 Download as PDF
//             </button>
//         </div>
//     );
// };

// export default ThermalInvoice;




// import React, { useContext, useRef, forwardRef } from "react";
// import jsPDF from "jspdf";
// import html2canvas from "html2canvas";
// import { useReactToPrint } from "react-to-print";
// import styles from "./ThermalInvoice.module.css";
// import AuthContext from "../../../store/auth-context";
// import ActiveStoreContext from "../../../store/ActiveStoreContext";

// // ✅ Forward ref so react-to-print can access it
// const InvoiceContent = forwardRef(({ invoiceDataMaster, activeStore, paidTotal }, ref) => (
//   <div className={styles.invoice} ref={ref}>
//     <h2 className={styles.title}>{activeStore?.storeName}</h2>
//     <div className={styles.storeAddress}>{activeStore?.storeAddress}</div>
//     <p>Invoice #: {invoiceDataMaster?.invoiceNumber}</p>
//     <p>Date: {invoiceDataMaster?.invoiceDate}</p>
//     <hr />

//     <p>
//       <strong>Client:</strong> {invoiceDataMaster?.clientData?.clientName}
//       <br />
//       {invoiceDataMaster?.clientData?.mobile}
//       <br />
//       {invoiceDataMaster?.clientData?.clientEmail}
//     </p>
//     <hr />

//     <table className={styles.table}>
//       <thead>
//         <tr>
//           <th>Item</th>
//           <th>Qty</th>
//           <th>Price</th>
//         </tr>
//       </thead>
//       <tbody>
//         {invoiceDataMaster?.productData?.map((item, index) => (
//           <tr key={index}>
//             <td>{item.productTitle}</td>
//             <td>{item.qty}</td>
//             <td>₹{item?.total}</td>
//           </tr>
//         ))}
//       </tbody>
//     </table>
//     <hr />

//     <h3>Total: ₹{invoiceDataMaster?.grandTotal}</h3>
//     <p>
//       <strong>Paid:</strong> ₹{paidTotal}
//       <br />
//       <strong>Due:</strong> ₹{invoiceDataMaster?.remainingAmount}
//     </p>
//     <hr />
//     <p className={styles.footer}>Thank you for visiting!</p>
//   </div>
// ));

// const ThermalInvoice = (props) => {
//   const { invoiceDataMaster } = props;
//   const printRef = useRef();
//   const authCtx = useContext(AuthContext);
//   const asCtx = useContext(ActiveStoreContext);

//   const activeStore = (() => {
//     try {
//       return asCtx?.activeStore && asCtx.activeStore.trim() !== ""
//         ? JSON.parse(asCtx.activeStore)
//         : null;
//     } catch {
//       return null;
//     }
//   })();

//   const paidTotal = invoiceDataMaster?.collectionData?.reduce(
//     (acc, item) => acc + item?.amount,
//     0
//   );

//   // --- Download PDF ---
//   const handleDownload = async () => {
//     const input = printRef.current;
//     const canvas = await html2canvas(input, { scale: 2 });
//     const imgData = canvas.toDataURL("image/png");

//     const pdf = new jsPDF({
//       orientation: "portrait",
//       unit: "mm",
//       format: [80, canvas.height * 0.2645], // 80mm width
//     });

//     pdf.addImage(imgData, "PNG", 0, 0, 80, (canvas.height * 80) / canvas.width);
//     pdf.save(`${invoiceDataMaster?.invoiceNumber}.pdf`);
//   };

//   // --- Direct Print ---
//   const handlePrint = useReactToPrint({
//     content: () => printRef.current,
//     documentTitle: invoiceDataMaster?.invoiceNumber,
//     pageStyle: `
//       @page {
//         size: 80mm auto;
//         margin: 0;
//       }
//       body {
//         margin: 0;
//         font-family: 'Courier New', monospace;
//         font-size: 12px;
//         line-height: 1.4;
//       }
//     `,
//   });

//   return (
//     <div className={styles.container}>
//       {/* ✅ Wrap content with forwardRef */}
//       <InvoiceContent
//         ref={printRef}
//         invoiceDataMaster={invoiceDataMaster}
//         activeStore={activeStore}
//         paidTotal={paidTotal}
//       />

//       {/* Buttons */}
//       <div className={styles.actions}>
//         <button className={styles.downloadBtn} onClick={handleDownload}>
//           Download PDF
//         </button>
//         <button className={styles.printBtn} onClick={handlePrint}>
//           Print Invoice
//         </button>
//       </div>
//     </div>
//   );
// };

// export default ThermalInvoice;

import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "./ThermalInvoice.module.css";
import AuthContext from "../../../store/auth-context";
import ActiveStoreContext from "../../../store/ActiveStoreContext";
import { urlToBase64 } from "../../../Helper/utility";

const ThermalInvoice = ({ invoiceDataMaster }) => {
  const printRef = useRef();
  const asCtx = useContext(ActiveStoreContext);

  const activeStore = (() => { 
    try { 
      return asCtx?.activeStore && asCtx.activeStore.trim() !== "" 
        ? JSON.parse(asCtx.activeStore) 
        : null; 
    } catch { 
      return null; 
    } 
  })();

  const paidTotal = invoiceDataMaster?.collectionData?.reduce(
    (acc, item) => acc + item?.amount,
    0
  );

  const handlePrint = () => {
    const printContents = printRef.current.innerHTML;
    const printWindow = window.open("", "_blank", "width=800,height=600");
    
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>Invoice ${invoiceDataMaster?.invoiceNumber || ''}</title>
          <style>
            * {
              margin: 0;
              padding: 0;
              box-sizing: border-box;
            }

            @page {
              size: 80mm auto;
              margin: 0mm;
            }

            html, body {
              width: 80mm;
              margin: 0 auto;
              padding: 0;
              background: white;
            }

            body {
              font-family: 'Courier New', monospace;
              font-size: 12px;
              line-height: 1.4;
              color: #000;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
              display: flex;
              justify-content: center;
            }

            .invoice-wrapper {
              width: 80mm;
              padding: 8px;
              background: white;
              margin: 0 auto;
            }

            .logoWrapper {
              text-align: center;
              margin-bottom: 8px;
            }

            .logoWrapper img {
              max-height: 40px;
              max-width: 50mm;
              width: auto;
              height: auto;
              object-fit: contain;
            }
            .logo{
              max-height: 40px;
              max-width: 50mm;
              width: auto;
              height: auto;
              object-fit: contain;
            }

            h2 {
              text-align: center;
              font-size: 16px;
              font-weight: bold;
              margin: 8px 0 4px 0;
            }

            .store-address {
              text-align: center;
              font-size: 10px;
              margin: 4px 0 8px 0;
              line-height: 1.3;
            }

            .invoice-row {
              display: flex;
              justify-content: space-between;
              font-size: 11px;
              margin: 2px 0;
            }

            .invoice-row p {
              margin: 0;
            }

            hr {
              border: none;
              border-top: 1px dashed #000;
              margin: 8px 0;
            }

            .client-info {
              font-size: 11px;
              margin: 8px 0;
              line-height: 1.4;
            }

            .client-info strong {
              font-weight: bold;
            }

            table {
              width: 100%;
              border-collapse: collapse;
              margin: 8px 0;
              font-size: 11px;
            }

            table th {
              text-align: left;
              padding: 4px 2px;
              font-weight: bold;
              border-bottom: 1px solid #000;
            }

            table th:last-child,
            table td:last-child {
              text-align: right;
            }

            table td {
              padding: 3px 2px;
              border-bottom: 1px dotted #ccc;
            }

            table tbody tr:last-child td {
              border-bottom: none;
            }

            .tax-section {
              margin: 8px 0;
              font-size: 10px;
            }

            .tax-row {
              display: flex;
              justify-content: space-between;
              margin: 2px 0;
            }

            .total-section {
              margin: 4px 0;
            }

            .total-row {
              display: table;
              width: 100%;
              font-size: 12px;
              margin: 3px 0;
            }

            .total-row > * {
              display: table-cell;
              margin: 0;
              padding: 0;
            }

            .total-row > *:first-child {
              text-align: left;
            }

            .total-row > *:last-child {
              text-align: right;
            }

            .total-row.grand {
              font-size: 14px;
              font-weight: bold;
              margin: 6px 0;
            }

            .total-row strong,
            .total-row h3 {
              margin: 0;
              display: table-cell;
            }

            .footer {
              text-align: center;
              font-size: 11px;
              margin-top: 12px;
              font-weight: bold;
            }

            @media print {
              @page {
                size: 80mm auto;
                margin: 0;
              }

              html, body {
                width: 80mm;
              }

              body {
                margin: 0 !important;
                padding: 0 !important;
              }
            }
          </style>
        </head>
        <body>
          <div class="invoice-wrapper">
            ${printContents}
          </div>
          <script>
            window.onload = function() {
              // Small delay to ensure images are loaded
              setTimeout(function() {
                window.print();
                // Close window after printing (optional)
                // window.onafterprint = function() { window.close(); };
              }, 250);
            };
          </script>
        </body>
      </html>
    `);
    
    printWindow.document.close();
  };

  const calculateTax = (totalAmount, taxPercent) => {
    if (totalAmount <= 0 || taxPercent < 0) {
      return { taxableValue: 0, totalTax: 0 };
    }

    const taxableValue = totalAmount / (1 + taxPercent / 100);
    const totalTax = totalAmount - taxableValue;

    return {
      taxableValue: parseFloat(taxableValue.toFixed(2)),
      totalTax: parseFloat(totalTax.toFixed(2))
    };
  };

  const [base64Logo, setBase64Logo] = useState(null);
  
  const fetchBase64Logo = async () => {
    try {
      const base64 = await urlToBase64(activeStore?.invoiceLogo);
      setBase64Logo(base64);
    } catch (error) {
      console.error("Error converting image to base64:", error);
    }
  };

  useEffect(() => {
    if (activeStore?.invoiceLogo) {
      fetchBase64Logo();
    }
  }, [activeStore?.invoiceLogo]);

  return (
    <div className={styles.container}>
      <div className={styles.invoice} ref={printRef}>
        <div className={styles.logoWrapper} style={{ display : "flex", justifyContent : "center", alignItems: "center", textAlign : "center" }} >
          {base64Logo ? (
            <img
              src={base64Logo}
              alt="Logo"
              className={styles.logo}
              style={{ height : "50px", maxWidth : "40mm", width : "auto", objectFit : "contain"}}
            />
          ) : activeStore?.invoiceLogo ? (
            <p>Loading logo...</p>
          ) : null}
        </div>
        
        <h2>{activeStore?.storeName || 'Store Name'}</h2>
        
        <div className={styles.storeAddress}>
          {activeStore?.storeAddress || ''}
        </div>
        
        {activeStore?.gstNumber && (
          <div className={styles.invoiceDataRow}>
            <p>GST Number:</p>
            <p>{activeStore.gstNumber}</p>
          </div>
        )}
        
        <div className={styles.invoiceDataRow}>
          <p>Invoice #:</p>
          <p>{invoiceDataMaster?.invoiceNumber || ''}</p>
        </div>
        
        <div className={styles.invoiceDataRow}>
          <p>Date:</p>
          <p>{invoiceDataMaster?.invoiceDate || ''}</p>
        </div>
        
        <hr />

        <p>
          <strong>Client:</strong> {invoiceDataMaster?.clientData?.clientName || 'N/A'}
          <br />
          {invoiceDataMaster?.clientData?.mobile || ''}
          {invoiceDataMaster?.clientData?.clientEmail && (
            <>
              <br />
              {invoiceDataMaster.clientData.clientEmail}
            </>
          )}
        </p>
        
        <hr />

        <table>
          <thead>
            <tr>
              <th>Item</th>
              <th>Qty</th>
              <th>Price</th>
            </tr>
          </thead>
          <tbody>
            {invoiceDataMaster?.productData?.map((item, idx) => (
              <tr key={idx}>
                <td>{item.productTitle || ''}</td>
                <td>{item.qty || 0}</td>
                <td>₹{item?.total || 0}</td>
              </tr>
            ))}
          </tbody>
        </table>
        
        <hr />
        
        {activeStore?.gstNumber && (
          <div className={styles.taxableWrapper}>
            <div className={styles.eachTaxRow}>
              <h4>Taxable Value</h4>
              <h4>₹{calculateTax(invoiceDataMaster?.grandTotal || 0, 5)?.taxableValue}</h4>
            </div>
            <div className={styles.eachTaxRow}>
              <h4>Total Tax (5%)</h4>
              <h4>₹{calculateTax(invoiceDataMaster?.grandTotal || 0, 5)?.totalTax}</h4>
            </div>
          </div>
        )}
        
        <div className={styles.totalRowWrapper} style={{display: 'table', width: '100%'}}>
          <h3 style={{display: 'table-cell', textAlign: 'left'}}>Total:</h3>
          <h3 style={{display: 'table-cell', textAlign: 'right'}}>₹{invoiceDataMaster?.grandTotal || 0}</h3>
        </div>
        
        <div className={styles.totalRowWrapper} style={{display: 'table', width: '100%'}}>
          <p style={{display: 'table-cell', textAlign: 'left'}}><strong>Paid:</strong></p>
          <p style={{display: 'table-cell', textAlign: 'right'}}>₹{paidTotal || 0}</p>
        </div>
        
        <div className={styles.totalRowWrapper} style={{display: 'table', width: '100%'}}>
          <p style={{display: 'table-cell', textAlign: 'left'}}><strong>Due:</strong></p>
          <p style={{display: 'table-cell', textAlign: 'right'}}>₹{invoiceDataMaster?.remainingAmount || 0}</p>
        </div>

        <hr />
        
        <p className="footer">Thank you for visiting!</p>
      </div>

      <div className={styles.actions}>
        <button onClick={handlePrint}>Print Invoice</button>
      </div>
    </div>
  );
};

export default ThermalInvoice;